import type { CommonService } from '../../components/common/common.service'

import { app } from '../../app.module'

/**
 * アカウント名の表示
 * @class AccountName
 */
class AccountName {
  private accountId: string
  private snsType: string

  constructor(
    private $scope,
    private $state,
    private CommonService: CommonService
  ) {}

  /**
   * アカウント詳細モーダルを表示
   * @returns {void}
   */
  public showAccountDetail(): void {
    this.CommonService.showAccountDetailModal(this.snsType, 'analytics', this.accountId)
  }
}

app.component('accountName', {
  bindings: {
    snsType: '@',
    accountId: '@',
    accountScreenName: '@',
    accountPictureUrl: '@',
  },
  template: require('./account-name.pug')(),
  controller: AccountName,
})
